import React from "react";
import Card from "react-bootstrap/Card";
import { ImPointRight } from "react-icons/im";
import { Helmet } from "react-helmet";

function AboutCard() {
  return (
    <Card className="quote-card-view">
      <Card.Body>
        <Helmet>
          <script type="application/ld+json">
            {`
              {
                "@context": "https://schema.org",
                "@type": "Person",
                "name": "Nisham Ghimire",
                "description": "CS student in Kathmandu University",
                "url": "https://www.nishamghimire.com.np",
                "sameAs": [
                  "https://www.linkedin.com/in/nisham-ghimire-473957170",
                  "https://github.com/nishamghimire5",
                  "https://twitter.com/nishamghimire10"
                ]
              }
            `}
          </script>
        </Helmet>
        <blockquote className="blockquote mb-0">
          <p style={{ textAlign: "justify" }}>
            I'm <span className="purple">Nisham Ghimire</span>, someone who sees the world through patterns, data, and strategic connections.
            While others get lost in technical details, I focus on the <span className="purple">strategic impact</span> of technology.
            <br />
            <br />
            I believe in combining <span className="purple">business acumen</span> with cutting-edge technical knowledge.
            My approach: understand the problem deeply, then leverage the right technology to create meaningful solutions.
            <br />
            <br />
            What drives my curiosity:
          </p>
          <ul>
            <li className="about-activity">
              <ImPointRight /> How <span className="purple">businesses really work</span> behind the scenes
            </li>
            <li className="about-activity">
              <ImPointRight /> <span className="purple">Data science & AI</span> - extracting strategic insights from complex datasets
            </li>
            <li className="about-activity">
              <ImPointRight /> <span className="purple">Cybersecurity landscapes</span> - understanding digital risks and protection strategies
            </li>
            <li className="about-activity">
              <ImPointRight /> The <span className="purple">psychology</span> of decision-making and human behavior
            </li>
            <li className="about-activity">
              <ImPointRight /> Building <span className="purple">intelligent systems</span> that solve real business problems
            </li>
            <li className="about-activity">
              <ImPointRight /> Creating <span className="purple">content that influences</span> strategic thinking
            </li>
          </ul>          <p style={{ color: "rgb(155 126 172)" }}>
            "Learn to conquer your brain and control your thoughts!" <br />{" "}
            <i style={{ fontSize: "15px" }}>then you are unstoppable</i>
          </p>
          <hr style={{ margin: "15px 0", borderColor: "rgba(155, 126, 172, 0.3)" }} />          <p style={{ textAlign: "justify", fontSize: "13px", lineHeight: "1.5", color: "rgb(180, 180, 180)", fontStyle: "italic" }}>
            My only objective in life is to have my <span className="purple">brain in full control</span>. The day I achieve that is the day <span className="purple">everything starts to change</span>.
            <br /><br />
            "Every day, the <span className="purple">world appears different</span> to me—not because it changes, but because my <span className="purple">perspective</span> does."
            <br /><br />
            "Become someone <span className="purple">you admire</span> — not someone <span className="purple">others admire</span>."
          </p>
          <footer className="blockquote-footer">Nisham</footer>
        </blockquote>
        <br />
        <br />
      </Card.Body>
    </Card>
  );
}

export default AboutCard;
